var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 0.625013C9.06567 0.622765 7.53414 1.03786 6.18936 1.82721C4.84457 2.61657 3.73554 3.75143 2.97733 5.11402C2.21913 6.47661 1.83939 8.01728 1.87751 9.57615C1.91564 11.135 2.37025 12.6553 3.19417 13.9792L0.625 19.375L6.02 16.8058C7.17059 17.5212 8.47157 17.9596 9.82046 18.0865C11.1693 18.2134 12.5293 18.0254 13.7931 17.5372C15.0569 17.049 16.1901 16.2739 17.1034 15.2732C18.0166 14.2724 18.685 13.0732 19.0559 11.7701C19.4267 10.467 19.4899 9.09559 19.2405 7.76392C18.991 6.43224 18.4357 5.17668 17.6183 4.09617C16.801 3.01566 15.7439 2.13971 14.5303 1.53736C13.3167 0.934997 11.9798 0.62268 10.625 0.625013Z",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsBubble);
export default __webpack_public_path__ + "static/media/sms-bubble.10fc37907f3d660a8961957c42e316c7.svg";
export { ForwardRef as ReactComponent };